import * as React from 'react';
import s from './LimitedTimeBanner.scss';
import { SaleBannerBase } from './SaleBannerBase/SaleBannerBase';
import { Trans } from 'react-i18next';
import { Text } from 'wix-style-react';
import { Pulsar } from './Pulsar';
import { RootStore, withInjectedRootStore } from 'providers';
import { Brands } from 'enums';

const LimitedTimeBannerComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const { brand } = rootStore.appStore.appContext;
  const textKey =
    brand === Brands.WIX
      ? 'Advanced.Plans_Limited_Time_Offer_banner'
      : brand === Brands.EDITOR_X
      ? 'Advanced.Plans_Limited_Time_Offer_banner_editorx'
      : 'Advanced.Plans_Limited_Time_Offer_banner';

  return (
    <div className={s.root} data-testid='limited-time-banner'>
      <SaleBannerBase className={s.limitedTimeBanner}>
        <SaleBannerBase.Icon>
          <Pulsar />
        </SaleBannerBase.Icon>
        <SaleBannerBase.Text>
          <Text size='small' weight='bold'>
            <Trans i18nKey={textKey}>
              Limited Time Offer - Save
              <Text skin='premium' tagName='span' size='small' weight='bold'>
                Up to 20%
              </Text>
              When You Upgrade rest
            </Trans>
          </Text>
        </SaleBannerBase.Text>
      </SaleBannerBase>
    </div>
  );
};

export const LimitedTimeBanner = withInjectedRootStore(LimitedTimeBannerComp);
